import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import baseURL from "../../../../Apiurs/Apiurls";
import Navbar from "../../../../Shared/AssociateNavbar/Navbar";
import qp from "quoted-printable";  // ✅ decode quoted-printable
import utf8 from "utf8"; 
import DOMPurify from "dompurify";
import "./RawEmail.css";

const RawEmailPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const leadInfo = location.state?.lead || null;

  const [emailHtml, setEmailHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const fetchRawEmail = async () => {
      try {
        const res = await fetch(`${baseURL}/api/raw-email/${id}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Failed to fetch email");

        let raw = data.raw_email_content || "";

        // ✅ Decode quoted-printable encoding
        raw = utf8.decode(qp.decode(raw));

        // Extract HTML block
        const htmlMatch = raw.match(
          /Content-Type:\s*text\/html[\s\S]*?(?=(--[0-9a-f\-]+|$))/i
        );

        let htmlContent = "";
        if (htmlMatch) {
          htmlContent = htmlMatch[0]
            .replace(/Content-Type:.*?\r?\n/gi, "")
            .replace(/Content-Transfer-Encoding:.*?\r?\n/gi, "")
            .trim();
        } else {
          const textMatch = raw.match(
            /Content-Type:\s*text\/plain[\s\S]*?(?=(--[0-9a-f\-]+|$))/i
          );
          htmlContent = textMatch
            ? `<pre>${textMatch[0]
                .replace(/Content-Type:.*?\r?\n/gi, "")
                .replace(/Content-Transfer-Encoding:.*?\r?\n/gi, "")
                .trim()}</pre>`
            : "<p>No content found</p>";
        }

        setEmailHtml(htmlContent);
      } catch (err) {
        console.error("Error fetching email:", err);
        setEmailHtml("<p>Failed to load email content.</p>");
      } finally {
        setLoading(false);
      }
    };

    fetchRawEmail();
  }, [id]);

  return (
    <div className="CollapseContainer" style={{ marginLeft: "30px" }}>
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <h2 className="page-title">Email Content</h2>

        {leadInfo && (
          <div className="raw-email-header">
            <div>
              <p><strong>From:</strong> {leadInfo.email}</p>
              <p><strong>To:</strong> support@yourdomain.com</p>
              <p><strong>Name:</strong> {leadInfo.lead_name}</p>
              <p><strong>Phone:</strong> {leadInfo.contact_number}</p>
            </div>
          </div>
        )}

        <div className="email-body">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div
              className="raw-email-content"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(emailHtml),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default RawEmailPage;
